import { useLocation, useHistory } from 'react-router-dom'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import { getHighestRole } from '../../../utils/utilityFuncs'
import { toggle } from '../../../actions/sidebar'
import { useDispatch, useSelector } from 'react-redux'


const NavChildButton = ({ text, url }) => {
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'))
  const isActive = location.pathname === url

  const onClick = (e) => {
    e.stopPropagation()
    if (isMobile) dispatch(toggle(false))
    history.push(url)
  }

  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        mx: '8px',
        my: '1px',
        pl: '32px',
        pr: '10px',
        height: '36px',
        borderRadius: '5px',
        cursor: 'pointer',
        backgroundColor: isActive ? 'rgba(255,255,255,0.15)' : 'transparent',
        transition: 'background-color 0.15s',
        userSelect: 'none',
        '&:hover': {
          backgroundColor: isActive ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.08)'
        }
      }}
    >
      {/* Dot indicator */}
      <Box
        sx={{
          width: '4px',
          height: '4px',
          borderRadius: '50%',
          flexShrink: 0,
          backgroundColor: isActive ? '#fff' : 'rgba(255,255,255,0.3)'
        }}
      />
      <Box
        component='span'
        sx={{
          fontSize: '13px',
          fontWeight: isActive ? 500 : 400,
          color: isActive ? '#fff' : 'rgba(255,255,255,0.7)',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          lineHeight: 1
        }}
      >
        {text}
      </Box>
    </Box>
  )
}

const NavParent = ({ nodes }) => {
  const { roles } = useSelector(state => state.auth.user)
  const isStudent = getHighestRole(roles).type === 'student'

  return (
    <Box sx={{ pb: '4px' }}>
      {Object.entries(nodes)
        .filter(([key]) => key !== 'keys')
        .filter(([, node]) => !(node.url === '/cansat/devices' && isStudent))
        .map(([key, node]) => (
          <NavChildButton key={key} text={node.text} url={node.url} />
        ))}
    </Box>
  )
}

export default NavParent
